import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button,
  Typography,
  Alert,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@mui/material';
import { adminAPI } from '../../utils/api';

const CandidateCreate = ({ onCandidateCreated }) => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [generatedPassword, setGeneratedPassword] = useState('');
  const [showPasswordDialog, setShowPasswordDialog] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const result = await adminAPI.createCandidate(email);

      // Show password in dialog
      setGeneratedPassword(result.password);
      setShowPasswordDialog(true);
      setEmail('');

      if (onCandidateCreated) {
        onCandidateCreated(result);
      }
    } catch (err) {
      setError(err.message || 'Failed to create candidate');
    } finally {
      setLoading(false);
    }
  };

  const handleCloseDialog = () => {
    setShowPasswordDialog(false);
    setGeneratedPassword('');
  };

  return (
    <>
      <Paper sx={{ p: 3 }}>
        <Typography variant="h5" gutterBottom>
          Create Candidate
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="Candidate Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            margin="normal"
            helperText="A password will be automatically generated"
          />

          <Button
            fullWidth
            variant="contained"
            color="primary"
            type="submit"
            disabled={loading}
            sx={{ mt: 2 }}
          >
            {loading ? 'Creating...' : 'Create Candidate'}
          </Button>
        </form>
      </Paper>

      {/* Password Display Dialog */}
      <Dialog open={showPasswordDialog} onClose={handleCloseDialog}>
        <DialogTitle>Candidate Created Successfully</DialogTitle>
        <DialogContent>
          <DialogContentText>
            The candidate account has been created. Please save this password as it will not be shown again.
          </DialogContentText>
          <Box
            sx={{
              mt: 2,
              p: 2,
              backgroundColor: '#f5f5f5',
              borderRadius: 1,
              textAlign: 'center',
            }}
          >
            <Typography variant="body2" color="text.secondary" gutterBottom>
              Generated Password:
            </Typography>
            <Typography
              variant="h5"
              sx={{
                fontFamily: 'monospace',
                fontWeight: 'bold',
                color: 'primary.main',
                letterSpacing: 2,
              }}
            >
              {generatedPassword}
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} variant="contained" color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CandidateCreate;
